import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";

export class BioMeterUI {

  constructor(el) {
    this.$el = $(el);
    this.progress = 0;
    this.mainTimeline = gsap.timeline({paused: true});

    this.cursor = this.$el.find(".lottie-animation");
    this.lottie = this.$el.find(".lottie-animation").data("lottie");

    // Make the biolevel meter clickable, showing a popup
    this.$el.on("click", () => {
      app.toggleTooltip(true, app.level + "_halfway_low_result_tooltip")
    })

    this.init();
  }

  init() {
    this.mainTimeline.fromTo(this, {
      progress: 0
    }, {
      progress: 1,
      duration: 1,
      ease: "linear",
      onUpdate: () => {
        // console.log(this.progress)
        this.lottie.setFrame(Math.ceil(this.lottie.totalFrames * this.progress));
      }
    }, 0);
    this.mainTimeline.fromTo(this.cursor, {
      y: 300
    }, {
      y: 50,
      duration: 1,
      ease: "linear",
    }, 0);
  }

  to(progress, duration = 0.5) {
    gsap.to(this.mainTimeline, {
      duration: duration,
      progress: progress,
      ease: "sine.out",
    });
  }

  reset() {
    this.to(0, 0)
  }

}
